import { ThemeUICSSObject } from '@apia/theme';
import iconsGallery from './iconsGallery';
/* IMPORT HERE */

const test: ThemeUICSSObject = {
  iconsGallery,
  /* PREPEND HERE */
};

export default test;
